import * as React from 'react'
import { PieChart } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-PROVIDER-RATIO`

interface IProps {
  ratio: number
}

export default function ProviderRatio(props: IProps) {
  const { ratio } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<PieChart />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{t(`${PRE}-RATIO`, { ratio })}</Text>
    </Bullet>
  )
}
